import { Banner } from '@ordr-as/umami-react'
import { Link } from 'react-router-dom'
import { formatDateAndTime } from '../../utils/stringUtils'
import { TerminalDto } from '../../../generated-api'

type ColumnHeader = Pick<
    TerminalDto,
    'externalId' | 'pspTerminalId' | 'name' | 'batteryLevel' | 'latestEventCode' | 'latestState' | 'created'
>

const columns: Record<keyof ColumnHeader, string> = {
    externalId: 'External ID',
    pspTerminalId: 'PSP terminal ID',
    name: 'Name',
    batteryLevel: 'Battery level',
    latestEventCode: 'Latest event code',
    latestState: 'Latest state',
    created: 'Created',
}

const TerminalList = ({ terminals }: { terminals: TerminalDto[] }) => (
    <div className="rounded-lg bg-brand-white shadow-lg py-4 mt-4">
        <div className="overflow-x-auto">
            <div className="min-w-full inline-block">
                <div className="overflow-hidden">
                    {terminals.length ? (
                        <table className="text-left min-w-full">
                            <thead className="text-grey-dark">
                                <tr>
                                    {Object.entries(columns)?.map(([, label], idx) => (
                                        <th key={idx} scope="col" className="font-normal py-2 px-5 whitespace-nowrap">
                                            {label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {terminals.map((terminal, idx) => (
                                    <tr key={idx} className="hover:bg-purple-lightest border-t border-grey-lightest">
                                        {Object.entries(columns).map(([col], idx) => (
                                            <td key={idx} className="py-4 px-5 whitespace-nowrap text-sm">
                                                {col === 'externalId' ? (
                                                    <Link
                                                        to={terminal.externalId}
                                                        className="py-4 cursor-pointer text-brand-primary"
                                                    >
                                                        {terminal[col as keyof ColumnHeader] as keyof TerminalDto}
                                                    </Link>
                                                ) : col === 'latestEventCode' ? (
                                                    <span>{terminal.latestEventCode ?? terminal.latestEventCode}</span>
                                                ) : col === 'latestState' ? (
                                                    <span>{terminal.latestState}</span>
                                                ) : col === 'created' ? (
                                                    <span>{formatDateAndTime(terminal.created?.toString() ?? '')}</span>
                                                ) : (
                                                    <div>
                                                        {terminal[col as keyof ColumnHeader] as keyof TerminalDto}
                                                    </div>
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <Banner kind="warn" stretch="parent" onClose={() => null}>
                            No terminals found
                        </Banner>
                    )}
                </div>
            </div>
        </div>
    </div>
)

export default TerminalList
